import { render } from "./UiTextAnim.vue?vue&type=template&id=21e157d1&scoped=true&lang=pug"
import script from "./UiTextAnim.vue?vue&type=script&lang=js"
export * from "./UiTextAnim.vue?vue&type=script&lang=js"

import "./UiTextAnim.vue?vue&type=style&index=0&id=21e157d1&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e157d1"]])

export default __exports__